import { useNavigate } from 'react-router-dom';

import { Button } from '@mui/material';
import { Routes } from 'common/constants/routes';


export type ReportFooterButtonsProps = {
    handleOpenReportModal: () => void;
    disableGenerateButton: boolean;
}

export const ReportFooterButtons = ({ handleOpenReportModal, disableGenerateButton }: ReportFooterButtonsProps) => {
    const navigate = useNavigate();

    const handleClickCancel = () => {
        navigate(`/${Routes.Reports}`);
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
                variant={'contained'}
                sx={{ marginRight: '1rem' }}
                onClick={handleOpenReportModal}
                disabled={disableGenerateButton}
            >
Generate
            </Button>
            <Button
                variant={'outlined'}
                onClick={handleClickCancel}
            >
Cancel
            </Button>
        </div>
    );
};
